import { createComponent } from '@mtfe/sweet';
import { setOadParams, oadLX, reportMonitorLog, statisticTime } from '@mtfe/sweet-oad';
import { ErrorPage, Tabs, Describe } from '@mtfe/sweet-components';
import { dom, common, eventBus } from '@mtfe/sweet-utils';
import http from '../../service/index';
import tpl from './dom.html';
import style from './style.less';
import onReady from './ready';
import {
    hideSkeleton,
    fetchAllData,
    getBottomTipID,
    getPoiContainerID,
    filterPoiList,
    filterCouponList,
} from '../../utils/index';

import WelfareTabs from '../../components/WelfareTabs/script';
import CouponComponent from '../../components/CouponComponent/script';
import RedBagComponent from '../../components/RedBagComponent/script';
import store from '../../store/index';
import { experimentBanner, experimentDefaultTab, experimentAddRedBagToCoupon } from './experiment';

const noActivity = 'b_waimai_vtilewlv_mv';
const { getTabContainerID } = Tabs;
const { createUniqueId, debounce } = common;
const indexID = createUniqueId();

const { storeCoupon, storeRedBag, storeCommon } = store;

const { storeDailyDeals, storeOptionalWelfare } = storeCoupon;
const { errorReportApi, successReportApi } = reportMonitorLog;

const Index = async () => {
    try {
        onReady();

        const index = await createIndexDom();

        storeCommon.loginSuccessCb = async () => {
            const indexComp = await createIndexDom(true);
            dom.$id(indexID).outerHTML = indexComp;
            eventBus.$emit('ready');
        };

        return index;
    } catch (error) {
        console.error(error);
        const logInfo = JSON.stringify(error.message || error.msg);
        errorReportApi.reportErrorPage(logInfo);
        return ErrorPage({ text: '暂无活动开启' });
    } finally {
        hideSkeleton();
    }
};

const createIndexDom = async (loginJust = false) => {
    statisticTime.startTime('init_business_request');
    try {
        // 初始化store
        store.init();
        const success = await initHandleCookie(loginJust);
        if (!success) {
            !loginJust && hideSkeleton();
            return ErrorPage({ text: 'Cookie处理失败' });
        }

        // 处理recallBizID
        const { data: tabsInfo } = await http.getCategoryInfo();
        // 初始化缓存
        initCache(tabsInfo);

        // 首页结构数据与实验数据请求
        const { data: structInfo } = await http.getStructConfig();
        storeCommon.structInfo = structInfo;

        // 结构信息，强依赖于后端。
        const {
            dom_wm_red_bag: domWmRedBag,
            dom_sg_red_bag: domSgRedBag,
            dom_wm_coupon: domWmCoupon,
            dom_sg_coupon: domSgCoupon,
        } = structInfo.struct;

        // 商家数据、券数据请求与分发
        const optionalWelfareInitRecallBizId = storeOptionalWelfare.tabsInfo[0].recallBizId;
        statisticTime.endTime('init_business_request');
        await Promise.all([
            dispatchCoupon(domWmCoupon),
            dispatchCoupon(domSgCoupon),
            dispatchRedBag(domWmRedBag),
            dispatchRedBag(domSgRedBag),
            dispatchLeftRecvNum(optionalWelfareInitRecallBizId),
        ]).catch((error) => {
            console.error(error);
            const logInfo = JSON.stringify(error.message || error.msg);
            try {
                errorReportApi.reportRequestError(logInfo);
            } catch (reportError) {
                console.error(reportError);
            }
            throw error;
        });

        // 判断是否渲染商家券专区
        const isShowCoupon =
            domWmCoupon.isShow &&
            storeDailyDeals.poiData[domWmCoupon.recallBizId].poiList.length > 0;
        storeCommon.isShowCoupon = isShowCoupon;

        // 判断是否渲染红包专区
        let isShowRedBag =
            domWmRedBag.isShow &&
            storeRedBag.poiData[domWmRedBag.recallBizId].poiList.length > 0 &&
            storeRedBag.effectData[domWmRedBag.recallBizId].giftInfo !== undefined;

        // 实验3 商家券专区中，每日优惠支持领取红包实验
        isShowRedBag = experimentAddRedBagToCoupon(isShowRedBag);
        storeCommon.isShowRedBag = isShowRedBag;

        const events = {};
        const data = {
            indexID,
            isShowCoupon,
            isShowRedBag,
        };
        // 配置-首页中默认展示哪个Tab
        const indexDefaultActiveTab = storeRedBag.recallBizId;

        // 实验1 每日优惠和福利自选的优先展示
        const couponComponentOptions = {
            defaultActiveKey: experimentDefaultTab(indexDefaultActiveTab),
        };
        // 实验2 分销页面增加鲜花banner和跳转
        await experimentBanner(data, events);

        // 按照参数渲染
        if (isShowCoupon && isShowRedBag) {
            const redBagComponent = await RedBagComponent();
            const couponComponent = await CouponComponent(couponComponentOptions);
            data.welfareTabs = WelfareTabs({
                defaultActiveTab: indexDefaultActiveTab,
                couponComponent,
                redBagComponent,
            });
            successReportApi.reportRenderSuccess('渲染成功');
        } else if (!isShowCoupon && isShowRedBag) {
            const redBagComponent = await RedBagComponent();
            data.redBagComponent = redBagComponent;
            successReportApi.reportRenderSuccess('渲染成功');
        } else if (isShowCoupon && !isShowRedBag) {
            const couponComponent = await CouponComponent(couponComponentOptions);
            data.couponComponent = couponComponent;
            successReportApi.reportRenderSuccess('渲染成功');
        } else {
            oadLX.mv(noActivity);
            errorReportApi.reportErrorPage('createIndexDom:您所在区域的活动优惠已被抢完');
            return ErrorPage({ text: '您所在区域的活动优惠已被抢完' });
        }

        const component = createComponent(tpl, { data, style }, events);
        return component;
    } catch (error) {
        console.error(error);
        const logInfo = JSON.stringify(error.message || error.msg);
        errorReportApi.reportErrorPage(logInfo);
        return ErrorPage({ text: '暂无活动开启' });
    }
};

/**
 * @param {Boolean} loginJust:是否在登录后的回调中调用
 * @returns
 */
const initHandleCookie = async (loginJust = false) => {
    const handleCookieRes = await http.actGeHandleCookie(loginJust);

    if (handleCookieRes && handleCookieRes.data) {
        // 设置全局参数，用于后面接口createAdParams内上传
        setOadParams(handleCookieRes.data);
        storeCommon.deviceId = handleCookieRes.data.deviceId;
        return true;
    }
    return false;
};
/**
 * 初始化缓存结构
 * @param {Object} tabsInfo 页面结构信息
 */
const initCache = function (tabsInfo) {
    // [红包配置，券配置]这个配置依赖于后端，后端配置不能随意更改，包括顺序
    const [redBagTabsInfo, couponTabsInfo] = tabsInfo.infos;

    // 领券专区初始化<-------start------->
    storeCoupon.recallBizId = couponTabsInfo.recallBizId;
    storeCoupon.tabsContainerID = getTabContainerID(couponTabsInfo.recallBizId);

    // [每日优惠，福利自选] 配置同样不能随意更改
    const [dailyDealsTabsInfo, optionalWelFareTabsInfo] = couponTabsInfo.children;
    // 每日优惠
    storeDailyDeals.recallBizId = dailyDealsTabsInfo.recallBizId;
    storeDailyDeals.tabsContainerID = getTabContainerID(dailyDealsTabsInfo.recallBizId);

    storeDailyDeals.tabsInfo = dailyDealsTabsInfo.children;
    storeDailyDeals.tabsInfo.forEach((item) => {
        storeDailyDeals.poiData[`${item.recallBizId}`] = {
            recallBizId: item.recallBizId,
            poiList: [],
            pageNo: 1,
            poiContainerID: getPoiContainerID(item.recallBizId),
            bottomTipID: getBottomTipID(item.recallBizId),
        };
        storeDailyDeals.effectData[`${item.recallBizId}`] = {
            recallBizId: item.recallBizId,
            couponList: [],
            gift_value: 0,
        };
    });

    // 福利自选
    storeOptionalWelfare.recallBizId = optionalWelFareTabsInfo.recallBizId;
    storeOptionalWelfare.tabsContainerID = getTabContainerID(optionalWelFareTabsInfo.recallBizId);

    storeOptionalWelfare.tabsInfo = optionalWelFareTabsInfo.children;
    storeOptionalWelfare.tabsInfo.forEach((item) => {
        storeOptionalWelfare.poiData[`${item.recallBizId}`] = {
            recallBizId: item.recallBizId,
            poiList: [],
            pageNo: 1,
            poiContainerID: getPoiContainerID(item.recallBizId),
            bottomTipID: getBottomTipID(item.recallBizId),
        };
    });
    // 领券专区初始化<-------end------->

    // 红包专区初始化<<-------start------->
    storeRedBag.recallBizId = redBagTabsInfo.recallBizId;
    storeRedBag.tabsInfo = redBagTabsInfo.children;
    storeRedBag.tabsContainerID = getTabContainerID(storeRedBag.recallBizId);
    storeRedBag.tabsInfo.forEach((item) => {
        storeRedBag.poiData[`${item.recallBizId}`] = {
            recallBizId: item.recallBizId,
            poiList: [],
            pageNo: 1,
            poiContainerID: getPoiContainerID(item.recallBizId),
            bottomTipID: getBottomTipID(item.recallBizId),
        };
        storeRedBag.effectData[`${item.recallBizId}`] = {
            recallBizId: item.recallBizId,
            giftInfo: undefined,
        };
    });
    // 红包专区初始化<<-------end------->
};
/**
 * 用于商家券专区相关数据请求与分发，通用于外卖与闪购
 * @param {object} domRedBag - 区域描述，来源于structInfo.struct
 */
const dispatchCoupon = async (domCoupon) => {
    const { effectData, poiData } = storeDailyDeals;

    if (poiData.hasOwnProperty(domCoupon.recallBizId)) {
        const currentRecallBizId = domCoupon.recallBizId;
        const couponData = await fetchAllData({
            listInfo: poiData[currentRecallBizId],
            isShowLoading: false,
        });
        if (couponData && couponData.infos) {
            // 过滤出带有券的商家
            effectData[currentRecallBizId].couponList.push(
                ...filterCouponList(filterPoiList(couponData.infos)),
            );
            effectData[currentRecallBizId].gift_value = Number(couponData.gift_value) / 100;
            poiData[currentRecallBizId].poiList.push(...filterPoiList(couponData.infos));
        }
    }
};
/**
 * 用于红包专区相关数据请求与分发，通用于外卖与闪购
 * @param {object} domRedBag - 区域描述，来源于structInfo.struct
 */
const dispatchRedBag = async (domRedBag) => {
    const { effectData, poiData } = storeRedBag;

    if (poiData.hasOwnProperty(domRedBag.recallBizId)) {
        const currentRecallBizId = domRedBag.recallBizId;

        const redBagData = await fetchAllData({
            listInfo: poiData[currentRecallBizId],
            isShowLoading: false,
        });
        if (redBagData && redBagData.infos) {
            if (
                redBagData.infos[0] &&
                redBagData.infos[0].giftInfo &&
                redBagData.infos[0].giftInfo.type === 2
            ) {
                effectData[currentRecallBizId] = redBagData.infos[0];
            }
            poiData[currentRecallBizId].poiList.push(...filterPoiList(redBagData.infos));
        }
    }
};
/**
 * 用于福利自选数据请求与分发
 * @param {string} recallBizId
 */
const dispatchLeftRecvNum = async (recallBizId) => {
    const { effectData, poiData } = storeOptionalWelfare;
    if (poiData.hasOwnProperty(recallBizId)) {
        const optionalWelfareData = await fetchAllData({
            listInfo: poiData[recallBizId],
            isShowLoading: false,
        });
        if (optionalWelfareData && optionalWelfareData.infos) {
            poiData[recallBizId].poiList.push(...filterPoiList(optionalWelfareData.infos));
        }
        if (optionalWelfareData && optionalWelfareData.leftRecvNum !== undefined) {
            effectData.leftRecvNum = optionalWelfareData.leftRecvNum;
        }
    }
};

export default Index;
